export default __webpack_public_path__ + "static/media/loading.9ca08101.gif";